import React from 'react'
import GenericError from './GenericError'

const NotFoundPage = () => {
  return (
    <GenericError
      error={{
        title: '抱歉，页面找不到了。如需联系技术人员，请扫码加群。',
      }}
      needDetail={false}
      resetErrorBoundary={() => console.log('')}
    />
  )
}

export default NotFoundPage
